import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import Contacts from '../../../../components/contacts/contacts';
import { AssetMgrsContactsService } from '../../../../services/contacts';

function InvestMgrsContacts() : ReactElement {
  const { id } = useParams<{ id: string }>();
  const service = new AssetMgrsContactsService(id || '');

  return (
    <Contacts service={service} />
  );
}

export default InvestMgrsContacts;
